var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.9998L4.68099 15.7237C4.7142 15.8566 4.73081 15.923 4.75045 15.981C4.94238 16.5477 5.45264 16.9461 6.04889 16.9948C6.10993 16.9998 6.1784 16.9998 6.31534 16.9998C6.48683 16.9998 6.57257 16.9998 6.64481 16.9928C7.35875 16.9236 7.92375 16.3586 7.993 15.6446C8 15.5724 8 15.4866 8 15.3152V4.62481M14.375 10.6248C15.8247 10.6248 17 9.44956 17 7.99981C17 6.55006 15.8247 5.37481 14.375 5.37481M8.1875 4.62481H5.375C3.51104 4.62481 2 6.13585 2 7.99981C2 9.86377 3.51104 11.3748 5.375 11.3748H8.1875C9.51232 11.3748 11.1329 12.085 12.3832 12.7665C13.1126 13.1642 13.4773 13.363 13.7162 13.3337C13.9377 13.3066 14.1052 13.2071 14.235 13.0256C14.375 12.8299 14.375 12.4383 14.375 11.6551V4.34453C14.375 3.56131 14.375 3.1697 14.235 2.97398C14.1052 2.79249 13.9377 2.69304 13.7162 2.66591C13.4773 2.63665 13.1126 2.83546 12.3832 3.23308C11.1329 3.91465 9.51232 4.62481 8.1875 4.62481Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncement);
export default __webpack_public_path__ + "static/media/IconAnnouncement.a52aa76e3a0d26ec2ddabe579828c56c.svg";
export { ForwardRef as ReactComponent };